// extracted by mini-css-extract-plugin
module.exports = {"userAvatar--default":"UserAvatar_userAvatar--default___OA31","userAvatar--image":"UserAvatar_userAvatar--image__qvVLz"};